export function formatGuatemalanDateTime(dateTime) {
    if(!dateTime) return '';
    let formatedDate = new Date(dateTime).toLocaleString('es-GT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
    
    return formatedDate;
}